<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="regulador.especialidades"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :color="item.ativo ? 'dark' : 'success'"
                    :title="item.ativo ? 'Desativar' : 'Ativar'"
                    @click="item.ativo = !item.ativo"
                    small
                >
                    <rkm-icon :icon="item.ativo ? 'ban' : 'check-circle'" />
                </rkm-button>

                <rkm-button
                    :disabled="disableDestroy(item)"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
export default {
    data() {

        return {
            fields: [
                { key: 'codigo', label: 'Código', sortable: true, class: 'col-min' },
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ],
        }
    },
    methods: {
        disableDestroy(especialidade) {

            return this.data.model.solicitantes.some(s => !!s.reguladores
                .find(r => r.infraestruturaId === this.regulador.infraestruturaId
                    && !!r.especialidades.find(e => e.id === especialidade.id)))
        },
        destroy(especialidade) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir a especialidade?',
                async () => this.regulador.especialidades.splice(this.regulador.especialidades.indexOf(especialidade), 1)
            )
        }
    },
    props: {
        data: { type: Object, required: true },
        regulador: { type: Object, required: true },
    }
}
</script>